const StatisticalDept = () =>
  import('@/views/main/live/statisticalDept/StatisticalDept.vue')
export default {
  path: '/main/live/statisticalDept',
  name: 'StatisticalDept',
  component: StatisticalDept,
  children: []
}
